import React, { useState } from "react";
import BootstrapIcon from "../Common/BootstrapIcon";
import MVMIcon from "../Common/MVMIcon";
export default function TeamControls({ teamId, teamName, imageUrl, onExpand, editable, expandable, }) {
    const [isAccordionOpened, setIsAccordionOpened] = useState(false);
    const onExpandHandler = () => {
        setIsAccordionOpened((prev) => !prev);
        onExpand();
    };
    const bsProps = {
        "data-bs-toggle": "collapse",
        "data-bs-target": `#collapse-${teamId}`,
    };
    return (React.createElement("div", null,
        editable && (React.createElement("a", { className: 'edit-team-trigger ms-3', role: 'button', "data-teamname": teamName, "data-teamid": teamId, "data-teamimage": imageUrl },
            React.createElement(BootstrapIcon, { height: 20, width: 20, icon: 'pencil-square' }))),
        expandable && (React.createElement("a", { onClick: onExpandHandler, className: 'ms-3', role: 'button', ...bsProps },
            React.createElement(MVMIcon, { className: `transition-transform-linear ${isAccordionOpened ? "rotate-back-90" : "rotate-90"}`, height: 16, width: 16, icon: 'right-arrow' })))));
}
